import React, {Component, Fragment} from "react";
import {connect} from 'react-redux'
import ProfileCardView from "../components/ProfileCardView";

class ProfileCardContainer extends Component{
    render() {
        const {authedUser, investor, borrower, connection} = this.props
        return(
            <Fragment>
                <ProfileCardView
                    profile={authedUser}
                    investor={investor}
                    borrower={borrower}
                    connection={connection}
                />
            </Fragment>
        )
    }
}

function mapStateToProps({authedUser, investor, borrower, connection}){
    return{
        authedUser,
        investor,
        borrower,
        connection,
    }
}
export default connect(mapStateToProps)(ProfileCardContainer)